var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
export default class View extends Component {
    render() {
        const _a = this.props, { children, style, flex, row, left, center, right } = _a, props = __rest(_a, ["children", "style", "flex", "row", "left", "center", "right"]);
        const styles = {
            display: (typeof flex === 'boolean') ? 'flex' : undefined,
            flex: Number(flex) || undefined,
            flexDirection: row ? 'row' : (typeof flex === 'boolean') ? 'column' : undefined,
            justifyContent: left
                ? 'flex-start'
                : right ? 'flex-end' : center ? 'center' : undefined,
            alignItems: center ? 'center' : undefined
        };
        const estilos = Object.assign(Object.assign({}, styles), style);
        return (React.createElement("div", Object.assign({}, props, { style: estilos }), children));
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/elements/View.tsx
// module id = 162
// module chunks = 0